import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import StatCard from "../../components/common/StatCard";
import { DASHBOARD_STRINGS, COMMON_STRINGS } from "../../constants/strings";

import PeopleIcon from "@mui/icons-material/People";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import UserBarChart from "../../components/charts/UserBarChart";
import StatusPieChart from "../../components/charts/StatusPieChart";

import { getDashboardStats } from "../../services/api";

// 🔥 Redux
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/snackbarSlice";

const DashboardPage = () => {
  const dispatch = useDispatch();

  const [stats, setStats] = useState({
    users: 0,
    bookings: 0,
    in_progress: 0,
    completed: 0,
  });

  const [loading, setLoading] = useState(false);

  // ================= FETCH =================
  const fetchDashboard = async () => {
    try {
      setLoading(true);

      const res = await getDashboardStats();

      console.log("Dashboard API:", res);

      // ✅ SAFE DATA HANDLING
      const data = res.data?.data || res.data || {};

      setStats({
        users: data.users || 0,
        bookings: data.bookings || 0,
        in_progress: data.in_progress || 0,
        completed: data.completed || 0,
      });

    } catch (err: any) {
      dispatch(
        showSnackbar({
          message:
            err.message || COMMON_STRINGS.SOMETHING_WENT_WRONG,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  return (
    <Box>
      {/* 🔥 TOP CARDS */}
      <Box
        sx={{
          mt: 2,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },
          gap: 2,
        }}
      >
        <StatCard
          title={DASHBOARD_STRINGS.TOTAL_USERS}
          value={stats.users}
          icon={<PeopleIcon />}
          bgColor="var(--primary-soft)"
          color="var(--primary-main)"
          loading={loading}
        />

        <StatCard
          title={DASHBOARD_STRINGS.TOTAL_BOOKINGS}
          value={stats.bookings}
          icon={<BookOnlineIcon />}
          bgColor="var(--blue-soft)"
          color="var(--blue)"
          loading={loading}
        />

        <StatCard
          title={DASHBOARD_STRINGS.PENDING}
          value={stats.in_progress}
          icon={<PendingActionsIcon />}
          bgColor="var(--warning-soft)"
          color="var(--warning)"
          loading={loading}
        />

        <StatCard
          title={DASHBOARD_STRINGS.COMPLETED}
          value={stats.completed}
          icon={<CheckCircleIcon />}
          bgColor="var(--success-soft)"
          color="var(--success)"
          loading={loading}
        />
      </Box>

      {/* 🔥 ANALYTICS */}
      <Box sx={{ mt: 4 }}>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            mb: 2,
            color: "var(--text-primary)",
          }}
        >
          {DASHBOARD_STRINGS.ANALYTICS_OVERVIEW}
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "1fr 1fr",
            },
            gap: 2,
          }}
        >
          {/* 📊 BAR CHART */}
          <Box sx={cardStyle}>
            <Typography sx={{ mb: 1 }}>
              {DASHBOARD_STRINGS.USER_METRICS}
            </Typography>

            {/* 🔥 pass dynamic data */}
            <UserBarChart data={stats} />
          </Box>

          {/* 🍩 PIE CHART */}
          <Box sx={cardStyle}>
            <Typography sx={{ mb: 1 }}>
              {DASHBOARD_STRINGS.DISTRIBUTION}
            </Typography>

            {/* 🔥 pass dynamic data */}
            <StatusPieChart data={stats} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const cardStyle = {
  backgroundColor: "var(--white)",
  p: 2,
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

export default DashboardPage;